module.exports = __webpack_public_path__ + "static/media/DonateCarousel_4.d5217c4c.jpg";